"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMemberLicenseArgsValidator = exports.updateMemberLicenseArgsSchema = exports.updateMemberRoleArgsValidator = exports.updateMemberRoleArgsSchema = exports.deleteMemberArgsValidator = exports.deleteMemberArgsSchema = exports.changeMemberNameArgsValidator = exports.changeMemberNameArgsSchema = exports.leaveCommunityArgsValidator = exports.leaveCommunityArgsSchema = exports.leavePreviewArgsValidator = exports.leavePreviewArgsSchema = exports.removeAppFromCommunityArgsValidator = exports.removeAppFromCommunityArgsSchema = exports.addAppToCommunityArgsValidator = exports.addAppToCommunityArgsSchema = exports.deleteCommunityArgsValidator = exports.deleteCommunityArgsSchema = exports.joinCommunityArgsValidator = exports.joinCommunityArgsSchema = exports.updateCommunityArgsValidator = exports.updateCommunityArgsSchema = exports.createCommunityArgsValidator = exports.createCommunityArgsSchema = exports.createCommunityFromArgs = exports.AccessibilityOptions = exports.CHAT_APP_ID = exports.PDF_APP_ID = exports.PDF_APP_ID_OLD = void 0;
var suretype_1 = require("suretype");
var common_1 = require("../common");
var members_1 = require("./members");
// ==========================
// constants
// ==========================
exports.PDF_APP_ID_OLD = "d5479039-a199-4936-9387-25c901190393";
// export const PDF_APP_ID = "c0e38628-bff8-4566-94da-f9f7cbda5a66"
// export const CHAT_APP_ID = "31ba76cc-52df-44c3-aed8-7691ce4e620c"
exports.PDF_APP_ID = "506597d2-ba42-4317-96d2-b4d03d614982";
exports.CHAT_APP_ID = "51ca3249-336c-43eb-aff5-77fa15d5b5f0";
// ==========================
// interfaces
// ==========================
var AccessibilityOptions;
(function (AccessibilityOptions) {
    AccessibilityOptions[AccessibilityOptions["Closed"] = 0] = "Closed";
    AccessibilityOptions[AccessibilityOptions["Open"] = 1] = "Open";
})(AccessibilityOptions = exports.AccessibilityOptions || (exports.AccessibilityOptions = {}));
// ==========================
// Utils
// ==========================
// --------------------------
// community
// --------------------------
function createCommunityFromArgs(args, inDevMode) {
    return {
        details: {
            name: args.name,
            shortDescription: args.shortDescription,
            hideMembers: false,
            apps: inDevMode ? [] : [exports.PDF_APP_ID, exports.CHAT_APP_ID]
        },
        // sort
        createdOn: new Date().getTime(),
        // filter
        plan: args.plan,
        accessibility: args.accessibility
    };
}
exports.createCommunityFromArgs = createCommunityFromArgs;
// ==========================
// Actions
// ==========================
// --------------------------
// create community
// --------------------------
var communityNameSchema = suretype_1.v.string().maxLength(200);
var communityDescriptionSchema = suretype_1.v.string().maxLength(1000);
exports.createCommunityArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("createCommunity").required(),
    communityId: common_1.idSchema.required(),
    name: communityNameSchema.required(),
    shortDescription: communityDescriptionSchema.required(),
    plan: suretype_1.v.string().enum("free", "patronage").required(),
    accessibility: suretype_1.v.number().enum(0, 1).required(),
});
exports.createCommunityArgsValidator = (0, suretype_1.compile)(exports.createCommunityArgsSchema);
// --------------------------
// update community
// --------------------------
exports.updateCommunityArgsSchema = suretype_1.v.object({
    communityId: common_1.idSchema.required(),
    details: suretype_1.v.object({
        name: communityNameSchema,
        shortDescription: communityDescriptionSchema,
        hideMembers: suretype_1.v.boolean(),
    }).required(),
    accessibility: suretype_1.v.number().anyOf([suretype_1.v.number().const(0), suretype_1.v.number().const(1)])
});
exports.updateCommunityArgsValidator = (0, suretype_1.compile)(exports.updateCommunityArgsSchema);
// --------------------------
// preview & join community
// --------------------------
exports.joinCommunityArgsSchema = suretype_1.v.object({
    via: suretype_1.v.string().enum("search", "invitation", "pdfViewer").required(),
    id: common_1.idSchema.required(),
    name: suretype_1.v.string(),
});
exports.joinCommunityArgsValidator = (0, suretype_1.compile)(exports.joinCommunityArgsSchema);
// --------------------------
// leave & delete community
// --------------------------
exports.deleteCommunityArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("deleteCommunity").required(),
    communityId: common_1.idSchema.required()
});
exports.deleteCommunityArgsValidator = (0, suretype_1.compile)(exports.deleteCommunityArgsSchema);
exports.addAppToCommunityArgsSchema = suretype_1.v.object({
    communityId: common_1.idSchema.required(),
    appId: common_1.idSchema.required()
});
exports.addAppToCommunityArgsValidator = (0, suretype_1.compile)(exports.addAppToCommunityArgsSchema);
exports.removeAppFromCommunityArgsSchema = suretype_1.v.object({
    communityId: common_1.idSchema.required(),
    appId: common_1.idSchema.required()
});
exports.removeAppFromCommunityArgsValidator = (0, suretype_1.compile)(exports.removeAppFromCommunityArgsSchema);
exports.leavePreviewArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("leavePreview").required(),
    communityId: common_1.idSchema.required()
});
exports.leavePreviewArgsValidator = (0, suretype_1.compile)(exports.leavePreviewArgsSchema);
exports.leaveCommunityArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("leaveCommunity").required(),
    communityId: common_1.idSchema.required()
});
exports.leaveCommunityArgsValidator = (0, suretype_1.compile)(exports.leaveCommunityArgsSchema);
exports.changeMemberNameArgsSchema = suretype_1.v.object({
    communityId: common_1.idSchema.required(),
    name: suretype_1.v.string().required()
});
exports.changeMemberNameArgsValidator = (0, suretype_1.compile)(exports.changeMemberNameArgsSchema);
exports.deleteMemberArgsSchema = suretype_1.v.object({
    communityId: common_1.idSchema.required(),
    memberId: common_1.idSchema.required()
});
exports.deleteMemberArgsValidator = (0, suretype_1.compile)(exports.deleteMemberArgsSchema);
exports.updateMemberRoleArgsSchema = suretype_1.v.object({
    communityId: common_1.idSchema.required(),
    memberId: common_1.idSchema.required(),
    role: members_1.memberRolesSchema.required()
});
exports.updateMemberRoleArgsValidator = (0, suretype_1.compile)(exports.updateMemberRoleArgsSchema);
// ==========================
// licenses
// ==========================
exports.updateMemberLicenseArgsSchema = suretype_1.v.object({
    communityId: common_1.idSchema.required(),
    appId: common_1.idSchema.required(),
    memberId: common_1.idSchema.required(),
    licenseId: common_1.idNullableSchema.required(),
});
exports.updateMemberLicenseArgsValidator = (0, suretype_1.compile)(exports.updateMemberLicenseArgsSchema);
